import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { localize } from 'helpers/translator/localize'
import CSSModules from 'react-css-modules'

import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import ImmersiveReaderVideoMp4 from 'assets/video/immersive-reader.mp4'
import ImmersiveReaderVideoWebm from 'assets/video/immersive-reader.webm'

import styles from './immersive_reader_overlay.scss'

class ImmersiveReaderOverlay extends PureComponent {

	createTitle() {
		return (
			<p styleName='title'>
				<span styleName='title--strong'>{localize('immersive_reader_overlay_title')}</span>
				{localize('immersive_reader_overlay_subtitle_1')}<br /><br />
				{localize('immersive_reader_overlay_subtitle_2')}
			</p>
		)
	}

	createAsset() {
		return (
			<Fragment>
				<video width="540" height="304" styleName='video' autoPlay='autoplay' muted controls playsInline>
					<source src={ImmersiveReaderVideoWebm} type="video/webm" />
					<source src={ImmersiveReaderVideoMp4} type="video/mp4" />
					{localize('video_not_supported')}
				</video>
			</Fragment>
		)
	}

	render() {

		return (
			<FullOverlay
				title={this.createTitle()}
				headerWithBorder={true}
				assetSource={this.createAsset()}
				primaryTextButton={localize('immersive_reader_overlay_primary_button')}
				primaryActionHandler={this.props.actions.confirm}
				secondaryTextButton={localize('immersive_reader_overlay_secondary_button')}
				secondaryActionHandler={this.props.actions.cancel}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		confirm: myLibraryActions.immersiveReaderConfirmed,
		cancel: myLibraryActions.immersiveReaderCancelled,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(CSSModules(ImmersiveReaderOverlay, styles, {allowMultiple: true}))
export { ImmersiveReaderOverlay }
